export function isNumberOdd(x) {
  return x & 1;
}

/*
export function isNumberOdd(x) {
  return x % 2
}
*/
